import React, { useEffect, useRef } from "react";
import "../../styles/ProgramIntroduction.css"
import "../../styles/Features.css";
import "../../styles/Pedagogy.css";
import features from "./featuresData"
import "../../styles/OurProgram.css";
import { OurProgram } from '../../assets/index'
import { Link, useNavigate } from 'react-router-dom';

const ProgramIntroduction = () => {

  const scrollRevealRefs = useRef([]);
  const navigate = useNavigate();

  const handleApplyNow1 = () => {
    navigate('/mba-in-hr');
  };
  const handleApplyNow2 = () => {
    navigate('/mba-in-finance');
  };
  const handleApplyNow3 = () => {
    navigate('/mba-in-sale');
  };
  const handleApplyNow4 = () => {
    navigate('/share-link');
  };

  useEffect(() => {
    const revealElements = document.querySelectorAll(".scroll-reveal");

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
        } else {
          entry.target.classList.remove("is-visible");
        }
      });
    }, { threshold: 0.8 });

    revealElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {

      revealElements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);

  useEffect(() => {
    const observerCallback = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");

          // Force the animation reset by re-adding/removing the class
          entry.target.classList.remove("is-visible");
          void entry.target.offsetWidth; // Trigger a reflow
          entry.target.classList.add("is-visible");
        } else {
          entry.target.classList.remove("is-visible");
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, { threshold: 0.7 });

    scrollRevealRefs.current.forEach((el) => {
      if (el) observer.observe(el);
    });

    return () => {
      scrollRevealRefs.current.forEach((el) => {
        if (el) observer.unobserve(el);
      });
    };
  }, []);

  useEffect(() => {
    const revealElements = document.querySelectorAll(".scroll-reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible"); // Add 'is-visible' when in view
          } else {
            entry.target.classList.remove("is-visible"); // Remove it when out of view
          }
        });
      },
      { threshold: 0.7 }
    );

    revealElements.forEach((element) => observer.observe(element));

    return () => {
      // Cleanup the observer when the component unmounts
      revealElements.forEach((element) => observer.unobserve(element));
    };
  }, []);

  const points = [
    "Classroom lectures by faculty members",
    "Case studies",
    "Project assignments",
    "Domestic and international industry visits",
    "Fully Wi-Fi enabled campus",
    "Frequent interaction with highly reputed professionals",
    "Developing,implementing,auditing business plan",
  ];

  useEffect(() => {
    const revealElements = document.querySelectorAll(".scroll-reveal");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible"); // Add the 'is-visible' class when in view
          } else {
            entry.target.classList.remove("is-visible"); // Remove the class when out of view
          }
        });
      },
      { threshold: 0.8 }
    );

    revealElements.forEach((element) => {
      observer.observe(element);
    });

    return () => {

      revealElements.forEach((element) => {
        observer.unobserve(element);
      });
    };
  }, []);
  return (
    <>

      <div className="program-intro-tank  xs:scale-50 " id="pi">
        <div className="program-intro-container">
          <div className="program-intro-content">
            <h1 className="program-title scroll-reveal">
              Program Introduction
              <span className="underline"></span>
            </h1>
            <p className="program-description scroll-reveal">
              Embark on a transformative journey with our <strong>2-Year MBA Finance Program!</strong> Designed to shape future business leaders, our comprehensive curriculum combines theoretical knowledge with practical skills, empowering you to thrive in the dynamic world of business.
            </p>
            <p className="program-highlight scroll-reveal">
              What sets us apart is our unique <strong>1-Year Job Opportunity</strong>, where you'll gain invaluable real-world experience, apply your learning, and develop essential business acumen.
            </p>
            <p className="program-extra scroll-reveal">
              As part of the program, you'll also have the opportunity to earn <strong>15 course certificates</strong> in specialized areas, further enhancing your expertise and boosting your career prospects. Join us and unlock your full potential for success in today's competitive corporate landscape.
            </p>
          </div>
        </div>
      </div>

      <div className="features-container">
        <div className="faqline"></div>
        <h2 className="faq-header text-center relative bottom-[0.5rem] text-4xl font-bold">Features</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card scroll-reveal"
              ref={(el) => (scrollRevealRefs.current[index] = el)}
            >
              <div className="f_icon">{feature.icon}</div>
              <div className="card_description">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="description">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="pedagogy-container">

        <div className="pline scroll-reveal"></div>
        <h2 className="pedagogy-title scroll-reveal">Pedagogy:</h2>
        <p className="pedagogy-description scroll-reveal">
          The teaching-learning cycle of this highly interactive MBA program
          involves a judicious mix of a wide range of pedagogical approaches:
        </p>
        <ul className="pedagogy-list">
          {points.map((point, index) => (
            <li key={index} className="pedagogy-item scroll-reveal" id="pedo">
              <span className="check-icon">✔</span>
              <span id="point">{point}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="our-program-container">
        <div className="pline scroll-reveal"></div>
        <h2 className="our-program-heading scroll-reveal">Our Programs:</h2>

        <div className="our-program-content ">
          <div className="our-program-image-section scroll-reveal">
            <img
              src={OurProgram}
              alt="MBA in Finance"
              className="our-program-image"
            />

            <div className="block sm:hidden w-full text-center mt-4" id="box2">
              <div className="our-program-image-overlay inline-block">
                <span className="relative">MBA IN FINANCE</span>
              </div>
            </div>

            <div className="our-program-subcontent relative right-[1rem] bottom-[7rem]">

              <div className="our-program-image-overlay relative sm:top-[6rem] lg:right-[12rem] hidden sm:block">
                <span className="text-[1.4rem]">MBA IN FINANCE</span>
              </div>

              <div className="our-program-footer">
                <div className="our-program-starsb">
                  {Array(5)
                    .fill(0)
                    .map((_, index) => (
                      <span key={index} className="our-program-star">
                        &#9733;
                      </span>
                    ))}
                </div>
              </div>

              <div className="our-program-footer-buttons relative top-[7rem]">
                <Link to='/share-link' onClick={() => window.scrollTo(0, 0)}><button className="p_btn our-program-apply-now">Apply Now</button></Link>
                <Link to='/mba-in-finance' onClick={() => window.scrollTo(0, 0)}><button className="p_btn our-program-know-more">Know More</button></Link>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
};

export default ProgramIntroduction;


{/* <div className="our-program-image-section scroll-reveal">
            <img src={OurProgram} alt="MBA in Finance" className="our-program-image"/>

            <div className="block sm:hidden w-full text-center mt-4" id="box2">
              <div className="our-program-image-overlay inline-block">
                <span className="relative">MBA IN HR</span>
              </div>
            </div>

            <div className="our-program-subcontent relative right-[1rem] bottom-[7rem]">

            <div className="our-program-image-overlay relative sm:top-[6rem] lg:right-[12rem] hidden sm:block">
                <span className="text-[1.4rem]">MBA IN HR</span>
              </div>

              <div className="our-program-footer">
                <div className="our-program-starsb">
                  {Array(5)
                    .fill(0)
                    .map((_, index) => (
                      <span key={index} className="our-program-star">
                        &#9733;
                      </span>
                    ))}
                </div>
              </div>

              <div className="our-program-footer-buttons relative top-[7rem]">
              <Link to='/share-link' onClick={() => window.scrollTo(0, 0)}><button className="p_btn our-program-apply-now">Apply Now</button></Link>
              <Link to='/mba-in-hr' onClick={() => window.scrollTo(0, 0)}><button className="p_btn our-program-know-more">Know More</button></Link>
              </div>
            </div>
          </div> */}


{/* <div className="our-program-image-section scroll-reveal">
            <img
              src={OurProgram}
              alt="MBA in Finance"
              className="our-program-image"/>

            <div className="block sm:hidden w-full text-center mt-4" id="box2">
              <div className="our-program-image-overlay inline-block">
                <span className="relative">MBA IN MARKETING</span>
                <span className="hidden sm:inline">MBA IN MARKETING & SALES</span>
              </div>
            </div>

            <div className="our-program-subcontent relative right-[1rem] bottom-[7rem]">

              <div className="our-program-image-overlay relative sm:top-[6rem] lg:right-[12rem] hidden sm:block">
                <span className="text-[1.4rem]">MBA IN MARKETING & SALES</span>
              </div>

              <div className="our-program-footer">
                <div className="our-program-starsb">
                  {Array(5)
                    .fill(0)
                    .map((_, index) => (
                      <span key={index} className="our-program-star">
                        &#9733;
                      </span>
                    ))}
                </div>
              </div>

              <div className="our-program-footer-buttons relative top-[7rem]">
              <Link to='/share-link' onClick={() => window.scrollTo(0, 0)}><button className="p_btn our-program-apply-now">Apply Now</button></Link>
              <Link to='/mba-in-sale' onClick={() => window.scrollTo(0, 0)}><button className="p_btn our-program-know-more">Know More</button></Link>
              </div>
            </div> */}
{/* </div> */ }